<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 9 / 23"
    viewBox="0 0 23 9"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M3.7 1.972c.945 0 1.71.766 1.71 1.71h1.71a3.42 3.42 0 0 0-6.84 0v1.71a3.42 3.42 0 0 0 6.84 0H5.41a1.71 1.71 0 1 1-3.42 0v-1.71c0-.944.766-1.71 1.71-1.71z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M19.947 3.682h-1.71a.855.855 0 1 1 0-1.71h1.71c.472 0 .855.383.855.855h1.71A2.565 2.565 0 0 0 19.947.262h-1.71a2.565 2.565 0 1 0 0 5.13h1.71a.855.855 0 1 1 0 1.71h-1.71a.855.855 0 0 1-.855-.855h-1.71a2.565 2.565 0 0 0 2.565 2.566h1.71a2.565 2.565 0 1 0 0-5.13z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M10.541 1.972h1.71c.473 0 .855.383.855.855h1.71A2.565 2.565 0 0 0 12.252.262h-1.71a2.565 2.565 0 1 0 0 5.13h1.71a.855.855 0 1 1 0 1.71h-1.71a.855.855 0 0 1-.855-.855h-1.71a2.565 2.565 0 0 0 2.565 2.566h1.71a2.565 2.565 0 0 0 0-5.13h-1.71a.855.855 0 1 1 0-1.711z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 23,
    },
  },
};
</script>
